import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettings } from 'projects/partner/src/app.settings';

@Injectable({
  providedIn: 'root'
})
export class ApiDocsRemote {
  
  constructor(private http: HttpClient, private appSettings: AppSettings) {}
  
  getDocsJson(): Observable<string> {
      return this.http.get<string>(this.appSettings.apiDocs.url);
  }
}
